export function mapGenderToLabel(gender?: string | null): string {
  const g = (gender || "").toString().toUpperCase();
  switch (g) {
    case "FEMALE":
      return "Woman";
    case "MALE":
      return "Man";
    case "INTERSEX":
      return "Intersex";
    default:
      return "-";
  }
}
